module.exports = __webpack_public_path__ + "static/media/telephone-white.91d96572.svg";